import { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const TelecallerRescheduleCalendar = ({ appointment }) => {
  const [selectedDate, setSelectedDate] = useState(null);

  return (
    <div className="card shadow-none mt-2">
      <div className="row align-items-end p-3">

        {/* Date Picker */}
        <div className="col-md-4">
          <label className="form-label fw-semibold mb-2">
            Select New Preferred Date
          </label>

          <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            minDate={new Date()}
            dateFormat="MMMM d, yyyy"
            placeholderText="Choose a date"
            className="form-control"
          />
        </div>

        {/* Confirm */}
        <div className="col-md-2">
          <button
            className="btn btn-outline-primary mt-4 w-100"
            onClick={() => {
              if (!selectedDate) {
                alert("Please select a date");
                return;
              }

              window.dispatchEvent(
                new CustomEvent("telecallerRescheduleClick", {
                  detail: {
                    selectedDate,
                    appointment,
                  },
                })
              );
            }}
          >
            Confirm
          </button>
        </div>

      </div>
    </div>
  );
};

export default TelecallerRescheduleCalendar;
